module.exports = __webpack_public_path__ + "img/ico_alert.ab8b2da.svg";